module.exports = DDC.Hysterics;